/**
 * What the review window offers for a decision: the box holds the review's suggestion or, without
 * one, the person's own text to edit; "Enviar mesmo assim" when the policy lets this person send it
 * as written (decision 0032), and the "cannot be sent" line only when it does not.
 */
export function gateReviewView(d: {
  verdict: "approve" | "rewrite" | "block";
  rewrittenText: string | null;
  canOverride: boolean;
}): {
  field: "gate.suggestion" | "gate.your_edit";
  override: boolean;
  blockedHint: boolean;
} {
  return {
    field: d.rewrittenText ? "gate.suggestion" : "gate.your_edit",
    override: d.canOverride,
    blockedHint: d.verdict === "block" && !d.canOverride,
  };
}
